import { Icon } from '@chakra-ui/react';

const PCSocialIconIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

<g>
	<path class="st0" d="M0.89,14.66c0.11-0.46,0.19-0.93,0.33-1.38c0.11-0.36,0.26-0.7,0.42-1.04c0.17-0.36,0.46-0.47,0.76-0.34
		c0.3,0.14,0.38,0.44,0.25,0.82c-0.2,0.56-0.43,1.11-0.54,1.69C1.86,15.65,2.09,16.83,2.69,18c0.5-1.17,1.37-1.84,2.55-2.08
		c-0.14-0.37-0.33-0.71-0.39-1.08c-0.2-1.12-0.13-2.19,0.68-3.1c1.24-1.39,3.64-1.16,4.52,0.48c0.63,1.17,0.59,2.35-0.01,3.53
		c-0.02,0.05-0.05,0.1-0.08,0.17c1.22,0.25,2.1,0.91,2.59,2.09c0.51-0.94,0.74-1.92,0.68-2.95c-0.1-1.72-0.81-3.16-2.21-4.19
		c-1.78-1.31-3.71-1.5-5.75-0.65c-0.11,0.05-0.21,0.11-0.33,0.15c-0.32,0.13-0.62,0.02-0.75-0.26C4.07,9.83,4.17,9.53,4.47,9.37
		c0.7-0.37,1.45-0.62,2.24-0.71c2.44-0.28,4.48,0.51,6.09,2.38c0.17,0.19,0.31,0.41,0.47,0.62c0.07-0.03,0.14-0.06,0.21-0.09
		c1.53-0.82,3.06-1.64,4.59-2.45c0.19-0.1,0.22-0.19,0.15-0.38c-0.47-1.28-0.45-2.57,0.01-3.85c0.16-0.45,0.59-0.59,0.91-0.32
		c0.23,0.2,0.22,0.44,0.13,0.7c-0.2,0.57-0.31,1.15-0.27,1.76c0.04,0.71,0.21,1.38,0.6,2.04c0.37-0.88,1.01-1.41,1.91-1.64
		c-0.36-0.62-0.38-1.28-0.29-1.95c0.16-1.2,1.2-2.05,2.38-2c1.2,0.05,2.15,1,2.22,2.22c0.03,0.59,0.02,1.18-0.32,1.73
		c0.9,0.24,1.54,0.76,1.92,1.65c0.32-0.53,0.5-1.06,0.56-1.63c0.21-1.99-0.55-3.52-2.27-4.54c-1.07-0.63-2.23-0.74-3.43-0.41
		c-0.18,0.05-0.35,0.11-0.53,0.15C21.46,2.7,21.2,2.56,21.1,2.3c-0.1-0.27,0-0.58,0.3-0.69c0.42-0.15,0.86-0.24,1.29-0.36
		c0.07-0.02,0.14-0.04,0.2-0.06c0.4,0,0.81,0,1.21,0c0.53,0.15,1.08,0.24,1.57,0.45C27.63,2.5,28.79,4,29.07,6.1
		c0.39,3.01-1.57,5.72-4.54,6.25c-2.25,0.4-4.1-0.36-5.52-2.15c-0.06-0.07-0.11-0.14-0.18-0.24c-1.67,0.89-3.33,1.78-5.02,2.68
		c0.72,1.78,0.73,3.55,0,5.35c1.67,0.89,3.34,1.78,4.97,2.66c0.41-0.42,0.78-0.87,1.22-1.21c1.64-1.29,3.47-1.58,5.45-0.91
		c0.37,0.12,0.53,0.37,0.46,0.67c-0.08,0.35-0.37,0.5-0.77,0.4c-0.38-0.09-0.76-0.21-1.15-0.26c-2.37-0.33-4.71,1.56-4.95,3.94
		c-0.1,0.97,0.07,1.88,0.56,2.79c0.38-0.88,1.01-1.42,1.92-1.65c-0.38-0.73-0.42-1.5-0.21-2.26c0.3-1.12,1.38-1.83,2.49-1.68
		c1.16,0.15,2,1.09,2.04,2.27c0.02,0.57,0,1.14-0.32,1.65c1.13,0.44,1.43,0.69,1.94,1.7c0.15-0.4,0.31-0.73,0.41-1.08
		c0.26-0.9,0.21-1.79-0.09-2.68c-0.05-0.14-0.09-0.3-0.08-0.45c0.02-0.25,0.18-0.42,0.43-0.47c0.25-0.05,0.51,0.06,0.61,0.32
		c0.14,0.4,0.29,0.8,0.34,1.21c0.28,2.04-0.34,3.77-1.89,5.14c-2.37,2.11-6.23,1.71-8.12-0.83c-1.22-1.64-1.48-3.43-0.83-5.37
		c0.05-0.13,0.08-0.23-0.08-0.31c-1.6-0.85-3.19-1.7-4.78-2.55c-0.02-0.01-0.04-0.01-0.08-0.02c-0.05,0.06-0.11,0.13-0.16,0.2
		c-1.43,1.94-3.35,2.89-5.75,2.84C4.26,21.97,1.5,19.57,1,16.51c-0.03-0.18-0.07-0.35-0.11-0.53C0.89,15.54,0.89,15.1,0.89,14.66z
		 M7.62,20.94c1.47-0.03,2.79-0.53,3.89-1.58c0.06-0.06,0.11-0.15,0.11-0.23c0.02-0.83-0.53-1.65-1.33-1.94
		c-0.38-0.14-0.77-0.24-1.16-0.33c-0.13-0.03-0.29-0.02-0.41,0.03c-0.61,0.25-1.25,0.33-1.85,0.1c-0.49-0.19-0.92-0.15-1.37,0.01
		c-0.1,0.04-0.21,0.05-0.32,0.08c-0.94,0.28-1.53,1.02-1.57,2c0,0.09,0.05,0.21,0.12,0.28C4.8,20.4,6.1,20.9,7.62,20.94z
		 M23.51,11.35c1.03-0.02,1.97-0.33,2.79-0.98c0.07-0.06,0.15-0.15,0.16-0.24c0.08-0.66-0.33-1.31-0.96-1.54
		c-0.26-0.09-0.53-0.16-0.79-0.22c-0.11-0.02-0.24-0.02-0.34,0.02c-0.47,0.18-0.96,0.24-1.43,0.08c-0.38-0.14-0.72-0.09-1.08,0.01
		c-0.87,0.24-1.25,0.68-1.3,1.57c-0.01,0.1,0.05,0.23,0.13,0.29C21.5,11.01,22.44,11.32,23.51,11.35z M23.53,28.33
		c1.01-0.03,1.95-0.33,2.77-0.98c0.07-0.06,0.14-0.15,0.15-0.24c0.08-0.68-0.34-1.32-0.99-1.55c-0.25-0.09-0.51-0.15-0.77-0.21
		c-0.11-0.02-0.24-0.02-0.34,0.02c-0.47,0.18-0.96,0.25-1.43,0.07c-0.39-0.14-0.74-0.08-1.11,0.02c-0.83,0.23-1.2,0.68-1.28,1.54
		c-0.01,0.16,0.03,0.25,0.15,0.34C21.52,28,22.46,28.31,23.53,28.33z M5.9,14.01c0,0.09-0.01,0.22,0,0.35
		c0.05,0.84,0.69,1.54,1.48,1.62c0.89,0.09,1.67-0.4,1.88-1.25c0.09-0.38,0.08-0.8,0.06-1.2c-0.03-0.67-0.39-1.16-0.99-1.44
		c-0.6-0.28-1.2-0.22-1.74,0.18C6.02,12.7,5.84,13.29,5.9,14.01z M22.29,6c0.01,0.11,0,0.22,0.02,0.33
		c0.08,0.66,0.57,1.11,1.19,1.11c0.62,0,1.12-0.43,1.2-1.09c0.03-0.28,0.02-0.57-0.03-0.85c-0.11-0.6-0.74-1.01-1.34-0.9
		C22.64,4.71,22.29,5.19,22.29,6z M24.72,22.99c-0.01-0.13-0.01-0.26-0.03-0.38c-0.1-0.62-0.6-1.05-1.19-1.05
		c-0.59,0-1.1,0.43-1.18,1.06c-0.04,0.3-0.03,0.61,0.03,0.9c0.13,0.66,0.83,1.05,1.48,0.86C24.42,24.2,24.71,23.74,24.72,22.99z"/>
	<path class="st0" d="M27.13,19.68c0.3,0.02,0.52,0.27,0.51,0.57c-0.01,0.3-0.28,0.55-0.58,0.53c-0.29-0.02-0.53-0.28-0.51-0.57
		C26.55,19.9,26.82,19.66,27.13,19.68z"/>
	<path class="st0" d="M19.37,3.23c0-0.3,0.23-0.54,0.53-0.55c0.3-0.01,0.57,0.25,0.56,0.55c0,0.29-0.25,0.54-0.54,0.55
		C19.62,3.79,19.37,3.54,19.37,3.23z"/>
	<path class="st0" d="M2.7,10.94c0.01-0.3,0.24-0.53,0.55-0.53c0.3,0,0.56,0.26,0.55,0.56c-0.01,0.29-0.27,0.54-0.56,0.54
		C2.95,11.5,2.7,11.24,2.7,10.94z"/>
</g>

	</Icon>
);

export default PCSocialIconIcon;
